export function toArray(array, data) {
  let arr = !Array.isArray(array) ? [] : array

  if (typeof data === 'object') {
    const index = arr.findIndex(i => i.id === data.id)

    if (index > -1) {
      const el = arr[index]

      arr.splice(index, 1)
      arr.unshift(el)
    } else {
      arr.unshift(data)

      if (data.relation) {
        let n = 0

        arr = arr.filter(i => {
          if (i.relation === data.relation) {
            if (n === 2) {
              return false
            }
            n++
          }

          return true
        })
      }
    }
  }
  const count = data.relation ? 16 : 8

  return arr.slice(0, count)
}
